var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEIInnovation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aInnovation{fill:#b30200;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aInnovation",
    d: "M11,0V3h2V0ZM4.223,2.809,2.809,4.223,4.93,6.344,6.344,4.93Zm15.555,0L17.656,4.93,19.07,6.344l2.121-2.121ZM12,5a7.015,7.015,0,0,0-7,7,6.939,6.939,0,0,0,4,6.234V21a2.015,2.015,0,0,0,2,2h2a2.015,2.015,0,0,0,2-2V18.234A6.939,6.939,0,0,0,19,12,7.015,7.015,0,0,0,12,5Zm0,2a5,5,0,0,1,1.666,9.709L13,16.943V21H11V16.943l-.666-.234A5,5,0,0,1,12,7ZM0,11v2H3V11Zm21,0v2h3V11ZM4.93,17.656,2.809,19.777l1.414,1.414L6.344,19.07Zm14.141,0L17.656,19.07l2.121,2.121,1.414-1.414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEIInnovation);
export default __webpack_public_path__ + "static/media/e_i_innovation.426a181c8ea74ffecc3e204ba8fa4e67.svg";
export { ForwardRef as ReactComponent };